import {
  PRODUCT_ARTICLE_IMAGE_HEIGHT,
  PRODUCT_ARTICLE_IMAGE_WIDTH,
} from "./BookListingItem";
import { SeriesItem } from "../types";
import { getPageLink } from "@/navigation/selectors";
import classNames from "classnames";
import NextLink from "next/link";
import Image from "next/image";
import {
  BookStencil,
  Canvas,
  Link,
  Typography,
} from "@cappelendamm/design-system/react";
import { ListingItemProps } from "./types";

export function SeriesListingItem({
  item,
  config,
}: ListingItemProps<SeriesItem>) {
  const { objectID: sku, imageUrl, name, slug } = item;
  const href = getPageLink({ pageType: "series", params: slug });
  return (
    <article
      className={classNames(
        "row-span-[var(--list-row-count)] grid min-w-0 grid-rows-subgrid gap-1 p-0",
        "active:rounded active:outline-3 active:outline-offset-4 active:outline-[var(--cvr-canvas-background)]",
      )}
    >
      <NextLink
        href={href}
        aria-labelledby={`item-${sku}`}
        className={classNames(
          "group relative grid min-w-0 grid-rows-subgrid no-underline",
          config?.fields?.series
            ? "row-span-[calc(var(--list-row-count)-1)]"
            : "row-span-full",
        )}
      >
        <div className="row-[1/-2] grid items-start gap-4">
          <Canvas className="px-2 py-2 md:px-6 md:py-2">
            {imageUrl ? (
              <Image
                src={imageUrl}
                className={classNames(
                  "transition-transform",
                  "sm:group-hover:scale-102",
                )}
                alt={`Omslag fra verk "${name}"`}
                width={PRODUCT_ARTICLE_IMAGE_WIDTH * 3}
                height={PRODUCT_ARTICLE_IMAGE_HEIGHT}
                quality={100}
              />
            ) : (
              <div className="flex gap-2">
                <BookStencil
                  style={
                    {
                      "--book-width": `${PRODUCT_ARTICLE_IMAGE_WIDTH}px`,
                    } as React.CSSProperties
                  }
                />
                <BookStencil
                  style={
                    {
                      "--book-width": `${PRODUCT_ARTICLE_IMAGE_WIDTH}px`,
                    } as React.CSSProperties
                  }
                />
              </div>
            )}
          </Canvas>
          <Typography
            id={`item-${sku}`}
            as="h3"
            variant="title-md"
            className={classNames("truncate", {
              "sm:group-hover:underline": href,
            })}
          >
            {name}
          </Typography>
        </div>
        <Link
          as="span"
          variant="inline"
          className="order-6 text-sm sm:group-hover:underline"
        >
          Les mer
        </Link>
      </NextLink>
    </article>
  );
}
